import { Loader as Loaderr } from "lucide-react"


type LoaderProps = {
    size?: number
}

export const Loader = ({ size = 15 }: LoaderProps) => {
    return <Loaderr size={size} className="animate-spin text-primary-400" />
}